import { FAQContent } from '../FAQContent';
import { FAQSidebar } from '../FAQSidebar';
import { StyledContainer } from './FAQ.styled';

const FAQ = () => {
	return (
		<StyledContainer>
			<FAQSidebar />
			<FAQContent />
		</StyledContainer>
	);
};

export { FAQ };
